import { createContext } from 'react';

export interface ModalContextType {
  onClose?: () => void
}

const initialContext: ModalContextType = {
  onClose: undefined,
};

export const ModalContext = createContext(initialContext);
